function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../geom/Location';
import Coordinate from '../geom/Coordinate';
import Node from './Node';
import ArrayList from '../../../../java/util/ArrayList';
import TreeMap from '../../../../java/util/TreeMap';
var NodeMap = /*#__PURE__*/function () {
  function NodeMap() {
    _classCallCheck(this, NodeMap);
    NodeMap.constructor_.apply(this, arguments);
  }
  return _createClass(NodeMap, [{
    key: "find",
    value: function find(coord) {
      return this.nodeMap.get(coord);
    }
  }, {
    key: "addNode",
    value: function addNode() {
      if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        var node = this.nodeMap.get(coord);
        if (node === null) {
          node = this.nodeFact.createNode(coord);
          this.nodeMap.put(coord, node);
        }
        return node;
      } else if (arguments[0] instanceof Node) {
        var n = arguments[0];
        var _node = this.nodeMap.get(n.getCoordinate());
        if (_node === null) {
          this.nodeMap.put(n.getCoordinate(), n);
          return n;
        }
        _node.mergeLabel(n);
        return _node;
      }
    }
  }, {
    key: "print",
    value: function print(out) {
      for (var it = this.iterator(); it.hasNext();) {
        var n = it.next();
        n.print(out);
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this.nodeMap.values().iterator();
    }
  }, {
    key: "values",
    value: function values() {
      return this.nodeMap.values();
    }
  }, {
    key: "getBoundaryNodes",
    value: function getBoundaryNodes(geomIndex) {
      var bdyNodes = new ArrayList();
      for (var i = this.iterator(); i.hasNext();) {
        var node = i.next();
        if (node.getLabel().getLocation(geomIndex) === Location.BOUNDARY) bdyNodes.add(node);
      }
      return bdyNodes;
    }
  }, {
    key: "add",
    value: function add(e) {
      var p = e.getCoordinate();
      var n = this.addNode(p);
      n.add(e);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NodeMap;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { NodeMap as default };
NodeMap.constructor_ = function () {
  this.nodeMap = new TreeMap();
  this.nodeFact = null;
  var nodeFact = arguments[0];
  this.nodeFact = nodeFact;
};